import {
  FlexBox,
  Icon,
  IconButton,
  List,
  Timestamp,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { memo, useCallback } from 'react';

import { appActions } from 'app/app.actions';
import { getChannelName } from 'app/utils/channelName';
import {
  ConversationDetails,
  ConversationDetailsLayout,
} from 'components/conversation/conversationDetails';
import { metaConversation } from 'components/conversation/utils/conversationObjectConverters';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { TimelineConversationType } from '../../timelineComponent';

import styles from './timelineItemRow.module.scss';

type TimelineItemRowProps = {
  index: number;
  conversation: TimelineConversationType;
  onConversationSelect: (csid: number) => void;
  toggleDropdown: () => void;
};

export const TimelineItemRow = memo(function TimelineItemRow({
  index,
  conversation,
  onConversationSelect,
  toggleDropdown,
}: TimelineItemRowProps): JSX.Element {
  const dispatch = useAppDispatch();

  const handlePreviewIconClick = useCallback(
    (event: React.MouseEvent): void => {
      event.stopPropagation();

      dispatch(
        appActions.showModal({
          modal: {
            type: 'app:conversationPreview',
            arg: { csid: conversation.id },
          },
        }),
      );
    },
    [conversation, dispatch],
  );

  const metaConversationInstance =
    metaConversation.from.timelineItem(conversation);

  return (
    <List.Item
      key={`${conversation.id}-${index}`}
      isLink
      className={styles.root}
      onClick={() => {
        if (conversation.id) {
          toggleDropdown();
          onConversationSelect(conversation.id);
          ampli.conversationTimelineNavigatedToConversation();
        }
      }}
    >
      <FlexBox
        alignItems="center"
        justifyContent="space-between"
        className={styles.wrapper}
      >
        <FlexBox alignItems="center" gap="200">
          <Tooltip content="Preview">
            <IconButton
              icon="eye"
              variant="tertiary"
              onClick={handlePreviewIconClick}
            />
          </Tooltip>

          <ConversationDetails
            layout={ConversationDetailsLayout.ConversationTimeline}
            showRequesterAvatar={false}
            conversationName={null}
            metaConversation={metaConversationInstance}
            titleRenderer={() =>
              conversation.title
                ? conversation.title
                : getChannelName(conversation.channel)
            }
            subTitleRenderer={() => (
              <span>
                <span>#{conversation.id}</span>
                <span> . </span>
                <Timestamp time={conversation.date} />
              </span>
            )}
          />
        </FlexBox>

        <Icon name="angle-right" />
      </FlexBox>
    </List.Item>
  );
});
